(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('CommandsDetailController', CommandsDetailController);

    CommandsDetailController.$inject = ['$rootScope', '$scope', '$state', 'TabActions', 'entity', 'objectUniqueCode'];

    function CommandsDetailController($rootScope, $scope, $state, TabActions, entity, objectUniqueCode) {
        var vm = this;

        vm.commands = [];
        vm.editorEnabled = [];
        vm.updateDescription = [];
        vm.objectUniqueCode = objectUniqueCode;

        if(vm.objectUniqueCode != null){
            localStorage.setItem("commands-detail-edit", JSON.stringify(vm.objectUniqueCode));
        } else {
            var uniqueCode = localStorage.getItem("commands-detail-edit");
            if(uniqueCode != null && uniqueCode != "null" && uniqueCode != undefined){
                vm.objectUniqueCode = JSON.parse(uniqueCode);
            }
        }

        vm.exportTable = exportTable;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.commands = entity;
                vm.commands.forEach(function (c) {
                    vm.editorEnabled.push(false);
                    vm.updateDescription.push("");
                });
            });
        }

        vm.enableEditor = function(index, edit) {
            if(edit == 0) {
                if(!vm.editorEnabled[index]) {
                    vm.editorEnabled[index] = true;
                }
            } else if(edit == 1) {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
            } else {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
                vm.updateDescription[index] = vm.commands[index].description;
            }
        };

        vm.saveUpdate = function(index) {
            vm.commands[index].description = vm.updateDescription[index];

            TabActions.update(vm.commands[index], onSuccess, onError);

            function onSuccess() {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
            }

            function onError(){}
        };

        function exportTable(type) {
            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    size: {0: 200, 1: 600},
                    tableName: vm.objectUniqueCode + ' - Commands'
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({type: type, escape: 'false', tableName: vm.objectUniqueCode + ' - Commands'});
            }
        }
    }
})();
